import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Colors } from 'advenio-components'
import DocumentsActions from '../../../Data/Redux/DocumentsRedux'

var Container = styled.div`
  display: flex;
  flex-direction: column;
`

var Section = styled.div`
  margin-bottom: 20px;
`

var SectionTitle = styled.h4`
  margin: 0 0 8px 0;
  font-size: 15px;
  font-weight: 700;
  color: #212B36;
`

var List = styled.ul`
  margin: 0;
  padding: 0 0 0 16px;
  list-style: disc;
`

var ListItem = styled.li`
  font-size: 14px;
  color: #637381;
  margin-bottom: 4px;
`

var GroupTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #212B36;
  margin-top: 8px;
  margin-bottom: 4px;
`

var CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background: #F5F6FA;
  border-radius: 4px;
`

var Checkbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

var CheckboxLabel = styled.label`
  font-size: 14px;
  color: #212B36;
  cursor: pointer;
`

var Warning = styled.div`
  background: #FFF3E0;
  border: 1px solid #FFB74D;
  border-radius: 4px;
  padding: 12px;
  font-size: 13px;
  color: #E65100;
  margin-bottom: 16px;
`

var ErrorMessage = styled.div`
  background: #FFEBEE;
  border: 1px solid #EF5350;
  border-radius: 4px;
  padding: 12px;
  font-size: 13px;
  color: #C62828;
  margin-bottom: 16px;
`

var DistributeRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`

var LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: ${Colors.blue500};
  z-index: 10;
`

var Summary = styled.div`
  padding: 12px;
  background: #E8F5E9;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #2E7D32;
`

class Step3Confirm extends Component {
  handleEmailChange = () => {
    this.props.setEmailNotification(!this.props.sendEmail)
  }

  handleDistribute = () => {
    var selectedDocuments = this.props.selectedDocuments
    var selectedStudents = this.props.selectedStudents
    var sendEmail = this.props.sendEmail

    if (selectedDocuments.length === 0 || selectedStudents.length === 0) return

    // Distribute first document (the API distributes one at a time)
    var documentId = selectedDocuments[0].id
    var studentIds = selectedStudents.map(function (s) { return s.id })

    this.props.distributeDocuments({
      documentId: documentId,
      studentIds: studentIds,
      sendEmail: sendEmail
    })
  }

  groupStudentsByClassroom = () => {
    var students = this.props.selectedStudents
    var groups = {}
    for (var i = 0; i < students.length; i++) {
      var classroom = students[i].classroom || 'Sin sala'
      if (!groups[classroom]) {
        groups[classroom] = []
      }
      groups[classroom].push(students[i])
    }
    return groups
  }

  render () {
    var selectedDocuments = this.props.selectedDocuments
    var selectedStudents = this.props.selectedStudents
    var sendEmail = this.props.sendEmail
    var duplicates = this.props.duplicates
    var distributing = this.props.distributing
    var error = this.props.error

    var groups = this.groupStudentsByClassroom()
    var tooManyStudents = selectedStudents.length > 200

    return (
      <Container>
        {distributing && (
          <LoadingOverlay>Distribuyendo documentos...</LoadingOverlay>
        )}

        <Summary>
          {'Se distribuirán ' + selectedDocuments.length + ' documento' + (selectedDocuments.length !== 1 ? 's' : '') +
           ' a ' + selectedStudents.length + ' estudiante' + (selectedStudents.length !== 1 ? 's' : '')}
        </Summary>

        <Section>
          <SectionTitle>Documentos seleccionados</SectionTitle>
          <List>
            {selectedDocuments.map(function (doc) {
              return <ListItem key={doc.id}>{doc.name}</ListItem>
            })}
          </List>
        </Section>

        <Section>
          <SectionTitle>Estudiantes seleccionados</SectionTitle>
          {Object.keys(groups).map(function (classroom) {
            return (
              <div key={classroom}>
                <GroupTitle>{classroom}</GroupTitle>
                <List>
                  {groups[classroom].map(function (student) {
                    return <ListItem key={student.id}>{student.name}</ListItem>
                  })}
                </List>
              </div>
            )
          })}
        </Section>

        {duplicates && duplicates.length > 0 && (
          <Warning>
            {'Se encontraron ' + duplicates.length + ' duplicado' + (duplicates.length !== 1 ? 's' : '') + '. Estos documentos ya existen en los repositorios de los estudiantes y serán omitidos.'}
          </Warning>
        )}

        {tooManyStudents && (
          <ErrorMessage>
            No se puede distribuir a más de 200 estudiantes a la vez. Por favor reduce la selección.
          </ErrorMessage>
        )}

        {error && (
          <ErrorMessage>{error}</ErrorMessage>
        )}

        <CheckboxRow>
          <Checkbox
            type='checkbox'
            checked={sendEmail}
            onChange={this.handleEmailChange}
            id='send-email-notification'
          />
          <CheckboxLabel htmlFor='send-email-notification'>
            Enviar notificación por email
          </CheckboxLabel>
        </CheckboxRow>

        <DistributeRow>
          <Button
            primary
            onClick={this.handleDistribute}
            loading={distributing}
            disabled={distributing || tooManyStudents || selectedDocuments.length === 0 || selectedStudents.length === 0}
          >
            Distribuir
          </Button>
        </DistributeRow>
      </Container>
    )
  }
}

Step3Confirm.propTypes = {
  selectedDocuments: PropTypes.array,
  selectedStudents: PropTypes.array,
  sendEmail: PropTypes.bool,
  duplicates: PropTypes.array,
  distributing: PropTypes.bool,
  error: PropTypes.string,
  setEmailNotification: PropTypes.func.isRequired,
  distributeDocuments: PropTypes.func.isRequired
}

Step3Confirm.defaultProps = {
  selectedDocuments: [],
  selectedStudents: [],
  sendEmail: true,
  duplicates: [],
  distributing: false,
  error: null
}

var mapStateToProps = function (state) {
  return {
    selectedDocuments: state.documents.wizard.selectedDocuments,
    selectedStudents: state.documents.wizard.selectedStudents,
    sendEmail: state.documents.wizard.sendEmail,
    duplicates: state.documents.wizard.duplicates,
    distributing: state.documents.wizard.distributing,
    error: state.documents.wizard.error
  }
}

var mapDispatchToProps = function (dispatch) {
  return {
    setEmailNotification: function (value) {
      return dispatch(DocumentsActions.setEmailNotification(value))
    },
    distributeDocuments: function (payload) {
      return dispatch(DocumentsActions.distributeDocumentsRequest(payload))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step3Confirm)



// WEBPACK FOOTER //
// ./src/Containers/Documents/DistributeWizard/Step3Confirm.jsx